<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
            <div class="titleWrap">
                Our Products
            </div>
        </div>
        <div class="bodySection">
            <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                    <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div>
                    <div class="textWrap">
                        <div class="iconWrap">
                            <div class="icon">
                                <img src="{{i.iconUrl}}">
                            </div>
                        </div>
                      
                        <div class="descRowWrap">
                           <div class="descValues" *ngFor="let o of i.desc">
                               <div class="imageDesc">
                                <img src="../../../../assets/images/patch/correct.svg">
                               </div>
                               <div class="textDesc">
                                {{o.value}}
                               </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="knowMoreWrap">
            <div class="buttonWrap">
                <button>
                    VIEW ALL PROJECTS
                </button>
            </div>
        </div>
    </div>
</div>